import { classesTag } from '@/commons/tags';

export const status_solicitacao_pagamento_clt_pendente = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_PENDENTE;
export const status_solicitacao_pagamento_clt_aprovada = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_APROVADA;
export const status_solicitacao_pagamento_clt_reprovada = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_REPROVADA;
export const status_solicitacao_pagamento_clt_pagamento = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_PAGAMENTO;
export const status_solicitacao_pagamento_clt_concluida = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_CONCLUIDA;
export const status_solicitacao_pagamento_clt_cancelada = import.meta.env.VITE_STATUS_SOLICITACAO_PAGAMENTO_CLT_CANCELADA;

// Status de solicitação de pagamento CLT -> cor semântica da tag
export const CORES_STATUS_PAGAMENTO_CLT = {
    [status_solicitacao_pagamento_clt_pendente]: 'roxo',
    [status_solicitacao_pagamento_clt_aprovada]: 'cyan',
    [status_solicitacao_pagamento_clt_pagamento]: 'amarelo',
    [status_solicitacao_pagamento_clt_concluida]: 'verde',
    [status_solicitacao_pagamento_clt_reprovada]: 'vermelho',
    [status_solicitacao_pagamento_clt_cancelada]: 'cinza',
};

// Status de solicitação de pagamento CLT -> ícone (PrimeIcons)
export const ICONES_STATUS_PAGAMENTO_CLT = {
    [status_solicitacao_pagamento_clt_pendente]: 'pi-eye',
    [status_solicitacao_pagamento_clt_aprovada]: 'pi-hourglass',
    [status_solicitacao_pagamento_clt_pagamento]: 'pi-hourglass',
    [status_solicitacao_pagamento_clt_concluida]: 'pi-check-circle',
    [status_solicitacao_pagamento_clt_reprovada]: 'pi-ban',
    [status_solicitacao_pagamento_clt_cancelada]: 'pi-times-circle',
};

export function getStatusSolicitacaoPagamentoCLT(status) {
    return classesTag(CORES_STATUS_PAGAMENTO_CLT[status] ?? 'cinza');
};